module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"rARkDGVF6YLtxAwDw6eBoKWQFR6VysEC","devKey":"rARkDGVF6YLtxAwDw6eBoKWQFR6VysEC","trackPage":true,"delayLoad":false,"delayLoadTime":1000,"manualLoad":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
